import React from 'react'
import PropTypes from 'prop-types'
// import { ShareButtons, generateShareIcon } from 'react-share';

// const { TwitterShareButton } = ShareButtons;
// const TwitterIcon = generateShareIcon('twitter');

class TwitterShare extends React.Component {
  render() {
    return (
      <div className="share">
        {/* <TwitterShareButton
          url={this.props.url}
          title={this.props.title}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton> */}
      </div>
    )
  }
}

TwitterShare.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default TwitterShare
